import { RadioGroupProps } from 'components/RadioGroup/Types'
import { RadioGroup } from 'components/RadioGroup'
import Styles from 'screens/VirtualMarketerOnboarding/CustomizeSchedule/CustomizeSchedule.module.scss'
import { ChipRadioButton } from 'components/RadioGroup/ChipRadioButton'
import cx from 'classnames'
import { useField } from 'formik'

interface Props extends Omit<RadioGroupProps, 'onChange' | 'value'> {
  chipSize?: 'lg' | 'xs' | 'sm' | 'md'
  chipClassName?: string
  onChange?: (value: number) => void
  value: number
}

export const DaysBeforeReviewRadioGroup = (props: Props) => {
  const { value, onChange, chipSize, chipClassName, ...rest } = props
  const chipProps = {
    className: cx(Styles.chip, chipClassName),
    deletable: false,
    variant: 'flat' as const,
    size: chipSize,
  }

  return (
    <RadioGroup
      value={String(value)}
      onChange={(value) => {
        value && onChange?.(parseInt(value))
      }}
      {...rest}
    >
      <ChipRadioButton value="4" {...chipProps}>
        4 days before
      </ChipRadioButton>
      <ChipRadioButton value="3" {...chipProps}>
        3 days before
      </ChipRadioButton>
      <ChipRadioButton value="2" {...chipProps}>
        2 days before
      </ChipRadioButton>
      <ChipRadioButton value="1" {...chipProps}>
        1 day before
      </ChipRadioButton>
    </RadioGroup>
  )
}

export const FormikDaysBeforeReviewRadioGroup = (props: Omit<Props, 'onChange' | 'value'> & { name: string }) => {
  const [field, , { setValue }] = useField<number>(props.name)

  return <DaysBeforeReviewRadioGroup {...props} value={field.value} onChange={setValue} />
}
